export default "__VITE_ASSET__Dn8pzbx9__"